import React, { useState } from 'react';
import { Icon, Tooltip } from 'antd';
import LightboxGroup from '../../../../LightboxGroup/LightboxGroup';
import styles from '../IconBlock.module.scss';

const ImageIcon = ({ attachment, attachments, getAttachmentUrl }) => {
  const [showPreview, setShowPreview] = useState(false);

  const handleClosePreview = () => setShowPreview(false);

  const handleOpenPreview = () => setShowPreview(true);

  return (
    <>
      <Tooltip title="Просмотр">
        <Icon
          type="file-image"
          className={styles.icon}
          style={{ cursor: 'pointer' }}
          onClick={handleOpenPreview}
        />
      </Tooltip>
      <LightboxGroup
        visible={showPreview}
        onClose={handleClosePreview}
        attachments={attachments}
        attachment={attachment}
        loader={getAttachmentUrl}
      />
    </>
  );
};

export default ImageIcon;
